export default function Mission() {
  return (
    <section data-testid="mission-section" id="mission" className="bg-[var(--bone)] py-24 md:py-32">
      <div className="container-x">
        {/* ABOUT */}
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-12 md:col-span-4">
            <div className="overline text-[var(--terracotta)]">About Us</div>
            <p className="font-mono text-xs text-[var(--muted)] mt-6 leading-relaxed">
              01 / About<br/>
              Focus: STEM + Infrastructure<br/>
              Region: Africa, esp. Nigeria<br/>
              In partnership with local communities
            </p>
          </div>

          <div className="col-span-12 md:col-span-8">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]">
              Advancing education across Africa — one classroom,
              one student, one <em className="text-[var(--terracotta)] not-italic">curious mind</em> at a time.
            </h2>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10">
              <p className="text-[var(--ink)]/75 leading-relaxed">
                The Irene Foundation is a charitable organization committed to advancing
                the quality of education across Africa — especially Nigeria. We focus on
                expanding access to Science, Technology, Engineering, and Mathematics
                (STEM) education while supporting the development of safe, modern, and
                sustainable classroom infrastructure. By addressing both the learning
                environment and the quality of instruction, we aim to create lasting,
                transformative changes in underserved communities.
              </p>
              <p className="text-[var(--ink)]/75 leading-relaxed">
                Across many regions in Africa, students face significant barriers to
                receiving a high-quality education: overcrowded classrooms, limited
                resources, and insufficient exposure to STEM learning opportunities. We
                were established to help bridge these gaps by investing in both people
                and infrastructure — so that students not only have a place to learn,
                but also the tools and knowledge to thrive in a rapidly evolving world.
              </p>
              <p className="text-[var(--ink)]/75 leading-relaxed md:col-span-2">
                Our programs equip schools with essential learning materials, improve
                physical classroom conditions, and introduce engaging, hands-on STEM
                experiences. We work in collaboration with local communities, educators,
                and partners to ensure that our initiatives are culturally relevant,
                sustainable, and impactful — empowering students to think critically,
                solve real-world problems, and pursue pathways that contribute to
                economic growth and community development. At the core of our work is
                the belief that education is a powerful driver of opportunity and
                equity.
              </p>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="divider-thin my-24" />

        {/* MISSION + VISION */}
        <div className="grid grid-cols-12 gap-8" data-testid="mission-vision-block">
          <div className="col-span-12 md:col-span-6">
            <div className="overline text-[var(--terracotta)]">Mission</div>
            <h3 className="font-serif text-3xl md:text-4xl mt-5 leading-[1.1] tracking-[-0.02em]">
              To improve the quality of education across Africa by expanding
              access to <em className="text-[var(--terracotta)] not-italic">STEM learning — especially for girls</em>{" "}
              — and developing safe, modern classroom infrastructure that
              empowers every student to succeed.
            </h3>
          </div>
          <div className="col-span-12 md:col-span-6 md:pl-10 md:border-l md:border-black/10">
            <div className="overline text-[var(--terracotta)]">Vision</div>
            <h3 className="font-serif text-3xl md:text-4xl mt-5 leading-[1.1] tracking-[-0.02em]">
              A future where <em className="text-[var(--terracotta)] not-italic">every child in Africa</em>
              {" "}has access to high-quality education, innovative learning environments,
              and the opportunity to reach their full potential.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}
